module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload_img"
  }, [(_vm.imageUrl) ? _c('div', {
    staticClass: "img"
  }, [_c('p', {
    style: ('background-image: url(' + _vm.imageUrl + ')')
  }), _vm._v(" "), _c('i'), _vm._v(" "), _c('b')]) : _c('div', {
    staticClass: "add"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.message))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48ad74de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/upload_img.vue
// module id = 840
// module chunks = 1